import { Avatar, Stack, useMenuButton } from "@chakra-ui/react";

export const PremiumMenuButton = (props: any) => {
  const buttonProps = useMenuButton(props);
  return (
    <Stack
      {...buttonProps}
      flexDirection="row"
      cursor="pointer"
      alignItems="center"
      className="profile-icon"
    >
      <Avatar
        boxSize="10"
        name={props?.name || props.user?.name}
        src={props?.image || props.user?.image}
      />
    </Stack>
  );
};
